import { z } from "zod/v4";

export const venueDomainStatusSchema = z.enum(["pending", "verified"]);
export type VenueDomainStatus = z.infer<typeof venueDomainStatusSchema>;

/** The venue's own domain for its booking page. */
export const venueDomainSchema = z.object({
	host: z.string(),
	status: venueDomainStatusSchema,
	verifiedAt: z.string().nullable(),
});
export type VenueDomain = z.infer<typeof venueDomainSchema>;

/** `target` is where the CNAME must point; null while the service has none configured. */
export const venueDomainsSchema = z.object({
	domains: z.array(venueDomainSchema),
	target: z.string().nullable(),
});
export type VenueDomains = z.infer<typeof venueDomainsSchema>;

/** What the DNS check found for a claimed host. */
export const dnsVerdictSchema = z.enum(["pointing", "not_resolving", "elsewhere"]);
export type DnsVerdict = z.infer<typeof dnsVerdictSchema>;

export const domainCheckSchema = z.object({ dns: dnsVerdictSchema, domain: venueDomainSchema });
export type DomainCheck = z.infer<typeof domainCheckSchema>;
